export enum SizeVariantsDisplayType {
  dropdown = 'dropdown',
  buttonBar = 'buttonBar',
}
